/* FSD Hero - Awakening */
(function(){
"use strict";
function init(root){
  if(!root||root.dataset.fsdInit)return; root.dataset.fsdInit='1';
  var REDUCED=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cvs=root.querySelector('.fsdh-fx'); if(!cvs)return;
  var ctx=cvs.getContext('2d');
  var W=0,H=0,DPR=1,MOBILE=innerWidth<620;
  function size(){
    DPR=Math.min(devicePixelRatio||1,2);
    var r=root.getBoundingClientRect(); W=r.width; H=r.height;
    cvs.width=W*DPR; cvs.height=H*DPR;
    cvs.style.width=W+'px'; cvs.style.height=H+'px';
    ctx.setTransform(DPR,0,0,DPR,0,0);
  }
  size(); addEventListener('resize',size);
  function rnd(a,b){return a+Math.random()*(b-a)}

  var kanji=['闘','超','覇'].map(function(ch,i){return{
    ch:ch,x:W*(.18+.32*i),y:H*rnd(.2,.75),size:rnd(150,250),
    vy:rnd(-.07,-.028),vx:rnd(-.035,.035),rot:rnd(-.22,.22),a:rnd(.02,.04)};});
  function drawKanji(){
    ctx.save(); ctx.font='700 1px "Noto Serif JP",serif';
    ctx.textAlign='center'; ctx.textBaseline='middle';
    for(var i=0;i<kanji.length;i++){var k=kanji[i];
      k.y+=k.vy; k.x+=k.vx;
      if(k.y<-k.size){k.y=H+k.size;k.x=rnd(W*.1,W*.9);}
      if(k.x<-k.size)k.x=W+k.size; if(k.x>W+k.size)k.x=-k.size;
      ctx.save(); ctx.translate(k.x,k.y); ctx.rotate(k.rot); ctx.scale(k.size,k.size);
      ctx.fillStyle='rgba(200,16,46,'+k.a+')'; ctx.fillText(k.ch,0,0); ctx.restore();}
    ctx.restore();
  }
  var wp=0;
  function drawWave(){
    wp+=.0042;
    for(var L=0;L<2;L++){
      var amp=13-L*4.5, base=H-6-L*13, s2=1+L*.55;
      ctx.beginPath(); ctx.moveTo(0,H);
      for(var x=0;x<=W;x+=7){
        ctx.lineTo(x, base-Math.sin(x*.0115+wp*s2)*amp-Math.sin(x*.0271+wp*1.9*s2)*amp*.45);
      }
      ctx.lineTo(W,H); ctx.closePath();
      ctx.fillStyle=L===0?'rgba(120,8,26,.17)':'rgba(200,16,46,.09)'; ctx.fill();
    }
  }
  function Petal(i){this.d=i*40;this.reset(true);}
  Petal.prototype.reset=function(a){
    this.x=rnd(-40,W+40); this.y=a?rnd(-H*.2,H):rnd(-90,-20);
    this.s=rnd(3.6,8.2); this.vy=rnd(.26,.72); this.sw=rnd(.5,1.5);
    this.sf=rnd(.0045,.012); this.ph=rnd(0,6.28);
    this.rot=rnd(0,6.28); this.vr=rnd(-.012,.012);
    this.a=rnd(.14,.42); this.warm=Math.random()<.38;};
  Petal.prototype.tick=function(t){
    if(t<this.d)return;
    this.y+=this.vy; this.x+=Math.sin(t*this.sf+this.ph)*this.sw; this.rot+=this.vr;
    if(this.y>H+40)this.reset(false);};
  Petal.prototype.draw=function(){
    ctx.save(); ctx.translate(this.x,this.y); ctx.rotate(this.rot);
    var s=this.s; ctx.beginPath(); ctx.moveTo(0,-s);
    ctx.bezierCurveTo(s*.92,-s*.5,s*.62,s*.72,0,s);
    ctx.bezierCurveTo(-s*.62,s*.72,-s*.92,-s*.5,0,-s);
    ctx.fillStyle=this.warm?'rgba(255,170,150,'+this.a+')':'rgba(244,228,232,'+(this.a*.82)+')';
    ctx.fill(); ctx.restore();};
  function Ember(i){this.d=i*26;this.reset(true);}
  Ember.prototype.reset=function(a){
    this.x=rnd(0,W); this.y=a?rnd(H*.45,H):H+8;
    this.vy=-rnd(.32,1.75); this.vx=rnd(-.28,.28); this.s=rnd(.4,2.3);
    this.r=205+(Math.random()*50|0); this.g=(Math.random()*34)|0;
    this.l=1; this.dec=rnd(.0028,.0082);};
  Ember.prototype.tick=function(t){
    if(t<this.d)return;
    this.x+=this.vx+Math.sin(t*.0012+this.x*.01)*.11; this.y+=this.vy; this.l-=this.dec;
    if(this.l<=0||this.y<-10)this.reset(false);};
  Ember.prototype.draw=function(){
    if(this.l<=0)return;
    ctx.beginPath(); ctx.arc(this.x,this.y,this.s,0,6.283);
    ctx.fillStyle='rgba('+this.r+','+this.g+',0,'+this.l+')'; ctx.fill();};
  var burst=[];
  function spawnBurst(cx,cy,n){
    for(var i=0;i<n;i++){var a=rnd(0,6.283),spd=rnd(1.6,11);
      burst.push({x:cx,y:cy,vx:Math.cos(a)*spd,vy:Math.sin(a)*spd*.78,l:1,
        dec:rnd(.012,.03),s:rnd(.6,2.6),hot:Math.random()<.42});}}
  function drawBurst(){
    for(var i=burst.length-1;i>=0;i--){var p=burst[i];
      p.x+=p.vx;p.y+=p.vy;p.vx*=.955;p.vy*=.955;p.vy+=.045;p.l-=p.dec;
      if(p.l<=0){burst.splice(i,1);continue}
      ctx.beginPath(); ctx.arc(p.x,p.y,p.s,0,6.283);
      ctx.fillStyle=p.hot?'rgba(255,214,120,'+p.l+')':'rgba(215,22,52,'+p.l+')'; ctx.fill();}}
  function bolt(x1,y1,x2,y2,d,det){
    if(d<det)return[[x1,y1],[x2,y2]];
    var mx=(x1+x2)/2+(Math.random()-.5)*d, my=(y1+y2)/2+(Math.random()-.5)*d*.3;
    return bolt(x1,y1,mx,my,d/2,det).slice(0,-1).concat(bolt(mx,my,x2,y2,d/2,det));}
  var strikes=[];
  function makeStrike(tx,ty,power){
    var main=bolt(tx+rnd(-W*.07,W*.07),-20,tx,ty,W*.17,3.5), br=[], n=power>.6?3:1;
    for(var i=0;i<n;i++){
      var k=(Math.random()*(main.length-6)|0)+3, p=main[k];
      br.push(bolt(p[0],p[1],p[0]+rnd(-W*.2,W*.2),p[1]+rnd(H*.08,H*.26),W*.08,3));}
    strikes.push({main:main,br:br,l:1,dec:power>.6?.052:.11,power:power});}
  function sp(pts,w,c){
    ctx.beginPath(); ctx.moveTo(pts[0][0],pts[0][1]);
    for(var i=1;i<pts.length;i++)ctx.lineTo(pts[i][0],pts[i][1]);
    ctx.lineWidth=w; ctx.strokeStyle=c; ctx.lineCap='round'; ctx.lineJoin='round'; ctx.stroke();}
  function drawStrikes(){
    for(var i=strikes.length-1;i>=0;i--){var s=strikes[i]; s.l-=s.dec;
      if(s.l<=0){strikes.splice(i,1);continue}
      var a=Math.max(0,s.l)*s.power;
      ctx.save(); ctx.globalCompositeOperation='lighter';
      sp(s.main,11,'rgba(200,16,46,'+(a*.17)+')');
      sp(s.main,4.5,'rgba(255,48,86,'+(a*.6)+')');
      sp(s.main,1.5,'rgba(255,245,245,'+a+')');
      for(var j=0;j<s.br.length;j++){
        sp(s.br[j],3,'rgba(255,48,86,'+(a*.3)+')');
        sp(s.br[j],1,'rgba(255,235,238,'+(a*.6)+')');}
      ctx.restore();}}

  var petals=[],embers=[],PN=MOBILE?24:42,EN=MOBILE?60:105,i;
  for(i=0;i<PN;i++)petals.push(new Petal(i));
  for(i=0;i<EN;i++)embers.push(new Ember(i));
  var t0=null,running=true;
  if(window.IntersectionObserver){
    new IntersectionObserver(function(e){running=e[0].isIntersecting;},{threshold:0}).observe(root);
  }
  function frame(ts){
    requestAnimationFrame(frame);
    if(!running)return;
    if(t0===null)t0=ts;
    var t=ts-t0,j;
    ctx.clearRect(0,0,W,H);
    var g=ctx.createRadialGradient(W/2,H,0,W/2,H,W*.58);
    g.addColorStop(0,'rgba(176,12,40,'+(.145+.038*Math.sin(t*.0008))+')');
    g.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle=g; ctx.fillRect(0,0,W,H);
    /* steady red pool behind the mark - the bolt art is lighten-blended
       over this, which is where its glow comes from */
    var g2=ctx.createRadialGradient(W/2,H*.44,0,W/2,H*.44,W*.3);
    g2.addColorStop(0,'rgba(200,16,46,.3)');
    g2.addColorStop(.45,'rgba(200,16,46,.1)');
    g2.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle=g2; ctx.fillRect(0,0,W,H);
    drawKanji(); drawWave();
    for(j=0;j<petals.length;j++){petals[j].tick(t);petals[j].draw();}
    for(j=0;j<embers.length;j++){embers[j].tick(t);embers[j].draw();}
    drawBurst(); drawStrikes();
  }
  requestAnimationFrame(frame);

  var seal=root.querySelector('.fsdh-seal'), logo=root.querySelector('.fsdh-logo');
  /* shake the hero itself: it is the blend root, so blending inside it
     stays correct, and its outer gradient edge is already black */
  function shake(mag,ms){
    if(REDUCED)return;
    var end=performance.now()+ms;
    (function step(){
      var left=end-performance.now();
      if(left<=0){root.style.transform='';return}
      var k=(left/ms)*mag;
      root.style.transform='translate3d('+rnd(-k,k).toFixed(2)+'px,'+rnd(-k,k).toFixed(2)+'px,0)';
      requestAnimationFrame(step);})();
  }
  if(REDUCED){ if(seal)seal.classList.add('turn'); if(logo)logo.classList.add('alive'); return; }

  setTimeout(function(){spawnBurst(W/2,H/2,34);shake(4,180);},820);
  if(seal)setTimeout(function(){
    seal.style.animation='none'; seal.style.opacity='.15';
    seal.style.transform='scale(1) rotate(0deg)';
    void seal.offsetWidth; seal.classList.add('turn');},1560);
  setTimeout(function(){
    var tx=W/2, ty=H/2;
    if(logo){var r=logo.getBoundingClientRect(),h=root.getBoundingClientRect();
      tx=r.left-h.left+r.width/2; ty=r.top-h.top+r.height/2;}
    makeStrike(tx,ty,1); spawnBurst(tx,ty,70); shake(13,420);},2060);
  /* electric flicker: brightness only. drop-shadow would trace the
     JPEG's rectangle instead of the artwork */
  if(logo)setTimeout(function(){
    var img=logo.querySelector('img'),k=0;
    var hot='contrast(1.75) brightness(1.85)';
    var id=setInterval(function(){
      img.style.filter=(k%2===0)?hot:'';
      if(++k>7){clearInterval(id);img.style.filter='';logo.classList.add('alive');}},72);},2320);
  setTimeout(function(){shake(5,170);},2700);
  setTimeout(function(){shake(6,170);},2880);
  setTimeout(function(){shake(9,170);},3060);
  setTimeout(function loopStrike(){
    makeStrike(rnd(W*.12,W*.88),rnd(H*.22,H*.5),rnd(.12,.26));
    setTimeout(loopStrike,rnd(5200,11000));},7000);
}
function boot(){
  var els=document.querySelectorAll('[data-fsd-hero]');
  for(var i=0;i<els.length;i++)init(els[i]);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
else boot();
document.addEventListener('shopify:section:load',boot);
})();